import set from "@rill/set";
import { defaults } from "lodash";
import get from "lodash/get";
import AddOtherExerciseModal from "../../../parts/modals/add-other-exercise";
import AddSecondaryMovementModal from "../../../parts/modals/add-secondary-movement";
import ExerciseLibraryVideoModal from "../../../parts/modals/ExerciseLibraryVideoModal";
import ExerciseLibrary from "./exercise-library";

const exerciseLibraryController = (app) => {
  app
    .use(set("heading", ["Admin", "ExerciseLibrary"]))
    .get("/exercise-library", async ({ load, locals, res, req }) => {
      defaults(req.query, { primary: "assistant" });

      const { query = {} } = req;
      const { modal = {}, primary: primaryQuery } = query;

      const primary = get(query, "modal.primary") || primaryQuery;

      await load("exerciseCatalog", { primary });

      const { activeUser, exerciseCatalog, activeUserToRequest } = locals;
      const { exerciseLibrary } = activeUser;
      const exercise =
        query.exercise && exerciseCatalog
          ? exerciseCatalog.find(({ _id }) => _id === query.exercise)
          : null;

      const intensityMeasure =
        get(activeUserToRequest, "intensityMeasure", "rpe") === "rpe"
          ? "RPE"
          : "RiR";
      const isRiR = intensityMeasure === "RiR";

      locals.modal = {
        "add-secondary-movement": (
          <AddSecondaryMovementModal
            isNew={!exercise}
            library={exerciseLibrary[primary] || []}
            index={0}
            primary={primary}
            user={activeUser}
            isCatalog
            exercise={exercise}
          />
        ),
        "add-other-exercise": (
          <AddOtherExerciseModal
            isNew={!exercise}
            library={exerciseLibrary.assistant || []}
            index={0}
            isCatalog
            exercise={exercise}
            intensityMeasure={intensityMeasure}
            isRiR={isRiR}
          />
        ),
        "exercise-library-video": (
          <ExerciseLibraryVideoModal
            exercise={exercise}
            athleteId={activeUser._id}
            primary={primary}
          />
        ),
      }[modal.type];

      res.body = <ExerciseLibrary />;
    });
};

export default exerciseLibraryController;
